import React, { Component } from 'react'

import { Modal, Row, Col, FormControl, FormLabel } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'

export default class ChangePassword extends Component<any> {
  state = {
    loading: false,
    show: true,
    password: {
      new: undefined,
      confirm: undefined,
    },
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open)
      
      this.setState({
        loading: false,
        show: true,
        password: {
          new: undefined,
          confirm: undefined,
        },
      })
  }

  onModalConfirm = () => {
    this.setState({ loading: true })

    this.props.callback(this.props.open.val, this.state.password).then(isSuccess => {
      isSuccess && this.setState({ loading: false })
    })
  }

  render() {

    return (
      <Modal show={this.state.show && this.props.open.show}>
        <Modal.Header>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>New Password</FormLabel></Col>
            <Col xs={5} sm={7}>
              <FormControl type="password" name="new" placeholder="New Password" style={{ marginTop: '5px' }} value={this.state.password.new || ""} onChange={this.handlePassword} />
            </Col>
          </Row>
          <Row>
            <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Confirm</FormLabel></Col>
            <Col xs={5} sm={7}>
              <FormControl type="password" name="confirm" placeholder="Confirm New Password" style={{ marginTop: '5px' }} value={this.state.password.confirm || ""} onChange={this.handlePassword} />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="success"
            loading={this.state.loading}
            onClick={this.onModalConfirm}
            disabled={
              ((this.state.password.new || "").length === 0 || (this.state.password.confirm || "").length === 0) ||
              this.state.password.new !== this.state.password.confirm
            }>
            {this.state.loading ? 'Please wait' : 'Save'}
          </Button>
          <Button bsStyle="default" onClick={() => { this.setState({ show: false }) }}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  handlePassword = (event) => {
    let password = this.state.password
    password[event.target.name] = event.target.value
    this.setState({ password })
  }

}